import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import {
  OpalApiComponent,
  OpalApiRequestBody,
  OpalApiResponseDocument,
} from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'UpdateBoardUserSettingV3'>['data']['attributes']
type RequestRelationships = OpalApiResponseDocument<
  'ReadBoardUserSettingV3',
  200
>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'board_user_setting'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  is_starred: false,
  is_subscribed: false,
  updated_at: new Date().toISOString(),
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes & Partial<OptionalAttributes>
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'board_user_setting'> => {
  return {
    id: uuidv4(),
    type: 'board_user_setting',
    attributes: {
      ...defaultAttributes,
      ...attributes,
    },
    relationships,
  }
}
